import { createContext, useContext, useState, useEffect, useRef } from 'react';
import { api, API_URL } from '../utils/api';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const checkedRef = useRef(false);

  useEffect(() => {
    // Guard against StrictMode double-invocation
    if (checkedRef.current) return;
    checkedRef.current = true;

    api.getMe()
      .then(setUser)
      .catch(() => {
        setUser(null);
        // Clear any stale/invalid auth cookie so it stops being sent
        fetch(`${API_URL}/auth/logout`, { method: 'POST', credentials: 'include' }).catch(() => {});
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    await api.login(email, password);
    const userData = await api.getMe();
    setUser(userData);
    return userData;
  };

  const requestOtp = async (phone_number) => {
    return api.requestOtp(phone_number);
  };

  const verifyOtp = async (phone_number, otp_code) => {
    await api.verifyOtp(phone_number, otp_code);
    const userData = await api.getMe();
    setUser(userData);
    return userData;
  };

  const register = async (email, password, name, gender, age) => {
    const response = await api.register(email, password, name, gender, age);
    return response;
  };

  const logout = async () => {
    await api.logout();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, requestOtp, verifyOtp, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
